import { render, staticRenderFns } from "./configValue.vue?vue&type=template&id=0de7d896&scoped=true"
import script from "./configValue.vue?vue&type=script&lang=js"
export * from "./configValue.vue?vue&type=script&lang=js"
import style0 from "./configValue.vue?vue&type=style&index=0&id=0de7d896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7d896",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RalfNavBar: require('/Users/apple/Sites/yikaowep/components/ralfNavBar.vue').default,Box: require('/Users/apple/Sites/yikaowep/components/Box.vue').default})
